<div class="container-fluid">
  <div class="row">
       <div class="col-12">
             <ngb-carousel  #carousel [interval]="5000" >
              @for (image of images; track image.name) {
                <ng-template ngbSlide>
                  <div class="wrapper" >
                    <img [src]="image.name" [alt]="image.caption" class="image-fluid mx-auto d-block" style="max-width:100%; max-height:100%;" >
                  </div>
                  <div class="carousel-caption">
                    <h3>{{ image.caption }}</h3>
                  </div>
                </ng-template>
              } @empty {
                <li>Slides no disponible</li>
              }
            </ngb-carousel>
        </div>
  </div>
</div>
